export default __webpack_public_path__ + "298af8d94604e3e29fee47f97bc2c85a.svg";